import React, { useState } from 'react'

import TextInputLabel from '~/components/text-input-label'
import { i18n } from '~/i18n'
import theme from '~/styles/theme'

import {
  Form,
  Field,
  FieldRow,
  StyledTextInput,
  StyledCardNumber,
  StyledExpiryDate,
  StyledSecurityCode,
} from './gr4vy-credit-card-form.styles'

const styles = {
  fontFamily: 'futura',
  height: '48px',
  color: theme.color.text.default,
  backgroundColor: theme.color.background.input.default,
  border: `1px solid ${theme.color.border.input.default}`,
  padding: '16px',
  '::placeholder': {
    color: theme.color.icon.subdued,
  },
  ':invalid': {
    color: theme.color.text.default,
  },
}

type Props = {
  nameOnCardError: boolean
  cardNumberError: boolean
  expiryDateError: boolean
  securityCodeError: boolean
  onCardNumberBlur: () => void
  onExpiryDateBlur: () => void
  onSecurityCodeBlur: () => void
  nameOnCard: string
  onNameOnCardChange: (nameOnCard: string) => void
}

export default function Gr4vyCreditCardForm({
  nameOnCardError,
  cardNumberError,
  expiryDateError,
  securityCodeError,
  onCardNumberBlur,
  onExpiryDateBlur,
  onSecurityCodeBlur,
  nameOnCard,
  onNameOnCardChange,
}: Props) {
  // Using a useState over useRef to force re-render on change
  const [wrapperRef, setWrapperRef] = useState<HTMLDivElement>(null)
  return (
    <Form ref={(newRef) => setWrapperRef(newRef)}>
      <Field>
        <TextInputLabel hasError={nameOnCardError}>
          {i18n.t('components.credit_card_form.name_label')}
        </TextInputLabel>
        <StyledTextInput
          hasError={nameOnCardError}
          onChange={({ target: { value } }) => onNameOnCardChange(value)}
          placeholder={i18n.t<string>(
            'components.credit_card_form.name_placeholder',
          )}
          value={nameOnCard}
        />
      </Field>
      <Field>
        <TextInputLabel hasError={cardNumberError}>
          {i18n.t('components.credit_card_form.number_label')}
        </TextInputLabel>
        <StyledCardNumber
          $hasError={cardNumberError}
          placeholder={i18n.t('components.credit_card_form.number_placeholder')}
          styles={styles}
          onBlur={onCardNumberBlur}
        />
      </Field>
      <FieldRow $isOddWidth={!!wrapperRef && wrapperRef.offsetWidth % 2 === 1}>
        <Field>
          <TextInputLabel hasError={expiryDateError}>
            {i18n.t('components.credit_card_form.expiration_label')}
          </TextInputLabel>
          <StyledExpiryDate
            $hasError={expiryDateError}
            placeholder={i18n.t(
              'components.credit_card_form.expiration_placeholder',
            )}
            styles={styles}
            onBlur={onExpiryDateBlur}
          />
        </Field>
        <Field>
          <TextInputLabel hasError={securityCodeError}>
            {i18n.t('components.credit_card_form.cvc_label')}
          </TextInputLabel>
          <StyledSecurityCode
            $hasError={securityCodeError}
            placeholder={i18n.t('components.credit_card_form.cvc_placeholder')}
            styles={styles}
            onBlur={onSecurityCodeBlur}
          />
        </Field>
      </FieldRow>
    </Form>
  )
}
